module.exports = __webpack_public_path__ + "img/tick-box.f11ab03c.svg";